<template lang="pug">
  .top
    .panel
      picture
        source(media='(min-width: 768px)' :srcset="`${rt}img/pc/panel_1.png`")
        img(:src="`${rt}img/panel_1.png`")
    a.btn-shindan(@click.prevent.stop="onClickShindan")
      picture
        source(media='(min-width: 768px)' :srcset="`${rt}img/pc/btn_shindan.png`")
        img(:src="`${rt}img/btn_shindan.png`")
    .questions(ref="q")
      picture
        source(media='(min-width: 768px)' :srcset="`${rt}img/pc/qbase.png`")
        img(:src="`${rt}img/qbase.png`")
      .qs
        .q
          picture
            source(media='(min-width: 768px)' :srcset="`${rt}img/pc/Q${current}.png`")
            img(:src="`${rt}img/Q${current}.png`")
      a.btn-yes(ref="yes" @click="onClickNext('1')")
        picture
          source(media='(min-width: 768px)' :srcset="`${rt}img/pc/btn_yes.png`")
          img(:src="`${rt}img/btn_yes.png`")
      a.btn-no(ref="no" @click="onClickNext('2')")
        picture
          source(media='(min-width: 768px)' :srcset="`${rt}img/pc/btn_no.png`")
          img(:src="`${rt}img/btn_no.png`")
      .cov.hd(ref="cov")
        picture
          source(media='(min-width: 768px)' :srcset="`${rt}img/pc/qbase2.png`")
          img(:src="`${rt}img/qbase2.png`")
</template>

<script>
import _ from 'lodash'
import $ from 'jquery'
const shindanData = require('../shindan.json')
export default {
  name: 'Top',
  props: ['rt'],
  data () {
    return {
      questions: []
    }
  },
  computed: {
    current () {
      return this.questions.length + 1
    }
  },
  methods: {
    onClickShindan () {
      $('html, body').animate({ scrollTop: $(this.$refs.q).offset().top })
    },
    onClickNext (ans) {
      this.questions.push(ans)
      if (this.questions.length === 7) {
        const result = this.computeResult()
        if (!result) {
          alert('error')
        } else {
          this.$router.push(`/result${result.replace('CL', '')}/`)
        }
      } else {
        $(this.$refs.cov).removeClass('hd')
        $(this.$refs.yes).addClass('mov')
        $(this.$refs.no).addClass('mov')
        setTimeout(() => {
          $(this.$refs.cov).addClass('hd')
        }, 400)
        setTimeout(() => {
          $(this.$refs.yes).removeClass('mov')
        }, 300)
        setTimeout(() => {
          $(this.$refs.no).removeClass('mov')
        }, 500)
      }
    },
    computeResult () {
      const quesStr = this.questions.join()
      let res = null
      _.forEach(shindanData, ({ answers, result }) => {
        if (quesStr === answers.join()) {
          res = result
          return false
        }
      })
      return res
    }
  }
}
</script>

<style lang="scss" scoped>
.top {
  width: 97%;
  margin-left: auto;
  margin-right: auto;
  margin-bottom: 7%;
  position: relative;
}
@media screen and (min-width:768px) {
  .top {
    max-width: 1170px;
    margin-bottom: 30px;
  }
}
img {
  width: 100%;
}
.btn-shindan {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  top: 31%;
  width: 80%;
  cursor: pointer;
}
@media screen and (min-width:768px) {
  .btn-shindan {
    top: 29.7%;
    width: 48.6%;
    transition: filter 0.2s ease;
    filter: saturate(1);
    &:hover {
      transition: filter 0.2s ease;
      filter: saturate(2.5);
    }
  }
}

.questions {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  bottom: 2%;
  width: 84%;
  .btn-yes {
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    top: 55%;
    width: 66%;
    cursor: pointer;
    img {
      margin-top: 0;
      transition: margin-top 0.5s ease-out;
    }
    &.mov img {
      transition: none;
      margin-top: 25px;
    }
  }
  .btn-no {
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    top: 72%;
    width: 67%;
    cursor: pointer;
    img {
      margin-top: 0;
      transition: margin-top 0.5s ease-out;
    }
    &.mov img {
      transition: none;
      margin-top: 15px;
    }
  }
  .qs {
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    top: 12%;
    width: 78%;
    .q {
      position:absolute;
      top: 0;
      left: 0;
    }
  }
  .cov {
    position: absolute;
    top:0;
    left:0;
    z-index: 1;
    pointer-events: none;
    opacity: 1;
    &.hd {
      transition: opacity 1s ease-out;
      opacity: 0;
    }
  }
}
@media screen and (min-width:768px) {
  .questions {
    width: 73.08%;
    bottom: 7%;
    .btn-yes {
      left: 11%;
      transform: none;
      top: 66%;
      width: 35%;
      transition: opacity 0.2s ease;
      opacity: 1;
      &:hover {
        transition: opacity 0.2s ease;
        opacity: 0.8;
      }
    }
    .btn-no {
      left: 51%;
      transform: none;
      top: 66%;
      width: 35%;
      transition: opacity 0.2s ease;
      opacity: 1;
      &:hover {
        transition: opacity 0.2s ease;
        opacity: 0.8;
      }
    }
    .qs {
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      top: 14.5%;
      width: 65.3%;
      .q {
        position:absolute;
        top: 0;
        left: 50%;
        transform: translateX(-50%);
        width: 100%;
      }
    }
  }
}

</style>
